import {uuidv4} from '@shared-types';
import {AbstractTriggerEntity} from '../trigger.entity';
import {TriggerEntityClassMetadata} from '../trigger.types';
import {Expose, instanceToPlain} from 'class-transformer';
import {IsDefined, IsPositive} from 'class-validator';
import {CancelAction, NotifyAction, TriggerActionEntity} from '../action/trigger-action.entity';
import {TriggerEventType} from '../event/trigger.event.types';

@GroupDecorator('trigger-entity', true)
@ClassMetaData<TriggerEntityClassMetadata>({
	name: 'notification-timeout-trigger',
	type: TriggerEventType.NotificationTimeout,
	label: 'components.trigger-editor.event.notification-timeout.label',
	summary: 'components.trigger-editor.event.notification-timeout.summary.[value]',
	updateValueClassSelector: 'dc-trigger-notification-timeout-value',
	availableActionClasses: [NotifyAction, CancelAction],
})
export class NotificationTimeoutTriggerEntity extends AbstractTriggerEntity {
	static override _uniqueId: string = uuidv4();

	/* -------------------  Value ------------------- */
	@Expose() @IsPositive({message: 'trigger.errors.invalidNotificationTimeoutValue'}) @IsDefined() public value = 1;

	/* ------------------- Action ------------------- */
	action: NotifyAction | CancelAction;

	constructor(init?: Partial<NotificationTimeoutTriggerEntity>) {
		super(TriggerEventType.NotificationTimeout, init);
		Object.assign(this, init);
		if (init?.action) this.action = TriggerActionEntity.create(init?.action?.type, init?.action);
	}

	public static is(entity: AbstractTriggerEntity): entity is NotificationTimeoutTriggerEntity {
		return entity.event === TriggerEventType.NotificationTimeout;
	}

	toJSON(): NotificationTimeoutTriggerEntity {
		return instanceToPlain(this, {}) as NotificationTimeoutTriggerEntity;
	}
}
